<div class="game-container" id="{{id}}"></div>
<div class="score-container" id="score-container">
    <div class="current-level"><span class="prefix">{{{t score_settings.score_text.level_prefix}}}</span><span class="data"></span></div>
    <div class="current-score"><span class="prefix">{{{t score_settings.score_text.score_prefix}}}</span><span class="data"></span></div>
    <div class="current-chain"><span class="prefix">{{{t score_settings.score_text.chain_prefix}}}</span><span class="data"></span></div>
    <div class="current-time"><span class="prefix">{{{t score_settings.score_text.time_prefix}}}</span><span class="data"></span></div>
</div>
<div class="game-progress">
    <div class="progress-bar">
        <div class="label"></div>
    </div>
</div>
